import { CheckNotes, InspectionCase, SummaryNotes } from '../inspection-cases';
import { Cases, Inspection } from '../inspection.dto';

export class InspectionFireExtinguishersDto extends InspectionCase {
  waterSupplyAccordingTable4?: InspectionCase;
  riskPerceptionMeetStandard?: InspectionCase;
  waterSupplyPipeDiameter?: InspectionCase;
  pumpDetails?: InspectionCase;
  pumpCommandBoard?: InspectionCase;
  pumpCannotStop?: InspectionCase;
  tapsLocked?: InspectionCase;
  tapsMarked?: InspectionCase;
  waterSupplyTapAndRollerInterval?: InspectionCase;
  a_4_4_2?: InspectionCase;
  a_5_3_2?: InspectionCase;
  a_5_6?: InspectionCase;
  a_5_7?: InspectionCase;
  a_5_8?: InspectionCase;
  a_6_1?: InspectionCase;
  a_6_2?: InspectionCase;
  a_8_1?: InspectionCase;
  a_8_2?: InspectionCase;
  a_8_3?: InspectionCase;

  summaryNotes?: SummaryNotes[];
}

export class InspectionFireExtinguishers
  extends InspectionFireExtinguishersDto
  implements Inspection
{
  constructor(
    data: InspectionFireExtinguishersDto = {
      title: 'בדיקת התקנת גלגילונים',
      isApplicable: true,
      summaryNotes: []
    }
  ) {
    super(data);

    this.waterSupplyAccordingTable4 = new InspectionCase({
      ...data.waterSupplyAccordingTable4,
      title: 'אספקת המים בהתאם לטבלה 4 בת"י 2206 חלק 1',
      section: '4.2'
    });
    this.riskPerceptionMeetStandard = new InspectionCase({
      ...data.riskPerceptionMeetStandard,
      title:
        'תפוסת הסיכון במבנה ונפח המים המתוכנן לגלגילונים תואם את דרישות ת"י 1596',
      section: '4.3'
    });
    this.waterSupplyPipeDiameter = new InspectionCase({
      ...data.waterSupplyPipeDiameter,
      title: 'קוטר צינור אספקת המים מתאים לחישוב ובכל מקרה לא קטן מ "1.',
      section: '4.7'
    });
    this.pumpDetails = new InspectionCase({
      ...data.pumpDetails,
      title: 'במידה והותקנה משאבה פרט את נתוניה',
      section: '4.7'
    });
    this.pumpCommandBoard = new InspectionCase({
      ...data.pumpCommandBoard,
      title:
        'לוח פיקוד המשאבה מאפשר המשך עבודה של 10 דקות לאחר שהלחץ במערכת הינו הלחץ מול ברז סגור.',
      section: '4.6.1'
    });
    this.pumpCannotStop = new InspectionCase({
      ...data.pumpCannotStop,
      title: 'ננקטו כל האמצעים שהמשאבה לא תפסיק את פעולתה לפני הזמן',
      section: '4.6.2'
    });
    this.tapsLocked = new InspectionCase({
      ...data.tapsLocked,
      title:
        'כל הברזים למעט הברז במבוא לגלגילון נעולים במצב פתוח או מחווטים לרכזת התרעות',
      section: '5.1'
    });
    this.tapsMarked = new InspectionCase({
      ...data.tapsMarked,
      title: 'כל הברזים והמגופים הסמויים מסומן מיקומם ומוגדר תפקודם',
      section: '5.2'
    });
    this.waterSupplyTapAndRollerInterval = new InspectionCase({
      ...data.waterSupplyTapAndRollerInterval,
      title:
        'הגלגילון מותקן כך שסביב ברז אספקת המים לגלגילון קיים מרווח של 10 ס"מ לפחות',
      section: '5.5'
    });
    this.a_4_4_2 = new InspectionCase({
      ...data.a_4_4_2,
      title: 'ידית השסתום באורך של 95 מ"מ לפחות',
      section: `2206-1 ס' 4.4.2`
    });
    this.a_5_3_2 = new InspectionCase({
      ...data.a_5_3_2,
      title: 'על דלת הארון הותקן שילוט זוהר בצבע אדום והכיתוב "אש" בצבע לבן',
      section: `2206.1 ס'5.3.2`
    });
    this.a_5_6 = new InspectionCase({
      ...data.a_5_6,
      title:
        'התוף מותקן כך שיהיה מרווח של 10 ס"מ לפחות במישור האנכי בין צלחת התוף להפרעה כלשהיא',
      section: '5.6'
    });
    this.a_5_7 = new InspectionCase({
      ...data.a_5_7,
      title: `הגלגילון מותקן בגובה של מקסימום 1.6 מ' ומאפשר פריסת הזרנוק ללא הפרעה`,
      section: '5.7'
    });
    this.a_5_8 = new InspectionCase({
      ...data.a_5_8,
      title:
        'מתאפשרת פתיחה וסגירה מקסימלית של דלת הארון (אם קיים) וברז כניסת המים נגיש ונראה בחזית הארון',
      section: '5.8'
    });
    this.a_6_1 = new InspectionCase({
      ...data.a_6_1,
      title:
        'צנרת אספקת המים המשותפת למערכת הכיבוי והשתייה מתאימה לת"י 1205 חלק 1 עבור צנרת פלדה',
      section: '6.1'
    });
    this.a_6_2 = new InspectionCase({
      ...data.a_6_2,
      title: 'הצנרת שאינה משותפת מתאימה לתקן הישראלי ת"י 4314',
      section: '6.2'
    });
    this.a_8_1 = new InspectionCase({
      ...data.a_8_1,
      title:
        'אם מותקנת משאבה: המשאבה נכנסה לעבודה באופן אוטומטי לאחר פתיחת ברז המזנק . לאחר סגירת ברז המזנק (מול ברז סגור) ,המשאבה המשיכה לפעול במשך 10 דקות לפחות',
      section: '8.1'
    });
    this.a_8_2 = new InspectionCase({
      ...data.a_8_2,
      title: 'לא נתגלו סימני נזילה',
      section: '8.2'
    });
    this.a_8_3 = new InspectionCase({
      ...data.a_8_3,
      title: 'ניתן לשלוף את הזרנוק  מהגלגילון בקלות לכל כיווני השימוש',
      section: '8.3'
    });

    this.summaryNotes = data.summaryNotes;
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.waterSupplyAccordingTable4.isApplicable ||
        this.waterSupplyAccordingTable4.isPassed) &&
        (!this.riskPerceptionMeetStandard.isApplicable ||
          this.riskPerceptionMeetStandard.isPassed) &&
        (!this.waterSupplyPipeDiameter.isApplicable ||
          this.waterSupplyPipeDiameter.isPassed) &&
        (!this.pumpCommandBoard.isApplicable ||
          this.pumpCommandBoard.isPassed) &&
        (!this.pumpCannotStop.isApplicable || this.pumpCannotStop.isPassed) &&
        (!this.pumpDetails.isApplicable || this.pumpDetails.isPassed) &&
        (!this.tapsLocked.isApplicable || this.tapsLocked.isPassed) &&
        (!this.tapsMarked.isApplicable || this.tapsMarked.isPassed) &&
        (!this.waterSupplyTapAndRollerInterval.isApplicable ||
          this.waterSupplyTapAndRollerInterval.isPassed) &&
        (!this.a_4_4_2.isApplicable || this.a_4_4_2.isPassed) &&
        (!this.a_5_3_2.isApplicable || this.a_5_3_2.isPassed) &&
        (!this.a_5_6.isApplicable || this.a_5_6.isPassed) &&
        (!this.a_5_7.isApplicable || this.a_5_7.isPassed) &&
        (!this.a_5_8.isApplicable || this.a_5_8.isPassed) &&
        (!this.a_6_1.isApplicable || this.a_6_1.isPassed) &&
        (!this.a_6_2.isApplicable || this.a_6_2.isPassed) &&
        (!this.a_8_1.isApplicable || this.a_8_1.isPassed) &&
        (!this.a_8_2.isApplicable || this.a_8_2.isPassed) &&
        (!this.a_8_3.isApplicable || this.a_8_3.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.waterSupplyAccordingTable4.getNotes(),
      ...this.riskPerceptionMeetStandard.getNotes(),
      ...this.waterSupplyPipeDiameter.getNotes(),
      ...this.pumpCommandBoard.getNotes(),
      ...this.pumpCannotStop.getNotes(),
      ...this.pumpDetails.getNotes(),
      ...this.tapsLocked.getNotes(),
      ...this.tapsMarked.getNotes(),
      ...this.waterSupplyTapAndRollerInterval.getNotes(),
      ...this.a_4_4_2.getNotes(),
      ...this.a_5_3_2.getNotes(),
      ...this.a_5_6.getNotes(),
      ...this.a_5_7.getNotes(),
      ...this.a_5_8.getNotes(),
      ...this.a_6_1.getNotes(),
      ...this.a_6_2.getNotes(),
      ...this.a_8_1.getNotes(),
      ...this.a_8_2.getNotes(),
      ...this.a_8_3.getNotes()
    ];
  }

  getCases(): Cases[] {
    return [];
  }
}
